import { configureStore } from '@reduxjs/toolkit';
import questionReducer from '../features/Questions/questionSlice';
import userReducer from '../features/userSlice';
export default configureStore({
  reducer: {
    question: questionReducer,
    user : userReducer,
  },
  // middleware:getDefaultMiddleware({
  //   serializableCheck : false,
  // }),
});
